export default __webpack_public_path__ + "static/210519_魔獄塔更新熱更預告_jp-34de97474402775e68a3ac31d7dd1f5a.webp";